import ViewPipeline from './ViewPipeline';

export default ViewPipeline;
